import { COMMON_TYPE_REDUCER } from '../../constants/common'

export const toggleShowLoading = (isLoading: boolean) => ({
    type: COMMON_TYPE_REDUCER.SHOW_LOADING,
    isShowLoading: isLoading
})
export const toggleViewHotelInMap = (isShow: boolean, latitude: any, longitude: any) => ({
    type: 'TOGGLE_VIEW_HOTEL_IN_MAP',
    payload: { isShow: isShow, latitude: latitude, longitude: longitude }
})

export const toggleSidebarMobile = (isOpen: boolean) => ({
    type: COMMON_TYPE_REDUCER.TOGGLE_SIDE_BAR_MOBILE,
    payload: isOpen,
})

export const toggleReviewInfo = (isOpen: boolean) => ({
    type: COMMON_TYPE_REDUCER.TOGGLE_REVIEW_INFO,
    payload: isOpen,
})

export const toggleShowAlertBox = (isOpenAlertBox: boolean) => ({
    type: COMMON_TYPE_REDUCER.TOGGLE_ALERT_BOX,
    payload: isOpenAlertBox,
})

export const saveAlertBoxText = (alertBoxText: string) => ({
    type: COMMON_TYPE_REDUCER.TOGGLE_ALERT_BOX_TEXT,
    payload: alertBoxText,
})

export const saveAlertBoxLink = (alertBoxLink: string) => ({
    type: COMMON_TYPE_REDUCER.TOGGLE_ALERT_BOX_LINK,
    payload: alertBoxLink,
})